import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import {
    initialStrategyParametersStreamState,
    StrategyParametersStreamDataState,
} from './stream/StrategyParametersStreamState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';
import {
    initialStrategyParametersComponentState,
    StrategyParametersComponentState,
} from 'widgets/strategyParams/store/component/StrategyParametersComponentState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { StrategyParametersConfigurationState } from 'widgets/strategyParams/store/configuration/StrategyParametersConfigurationState';

export type StrategyParametersWidgetState =
    StreamingWidgetState<StrategyParametersStreamDataState> &
        WidgetWithConfigState<StrategyParametersConfigurationState> &
        WidgetWithComponentState<StrategyParametersComponentState>;

export interface StrategyParametersWidgetsState {
    [widgetKey: string]: StrategyParametersWidgetState;
}

export const initialStrategyParametersWidgetState: StrategyParametersWidgetState =
    {
        stream: initialStrategyParametersStreamState,
        component: initialStrategyParametersComponentState,
        config: {},
    };

export const initialStrategyParametersWidgetsState: StrategyParametersWidgetsState =
    {};
